"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var Interwalk = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Interwalk, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(Interwalk);

  function Interwalk() {
    (0, _classCallCheck2["default"])(this, Interwalk);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Interwalk, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], this.props, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M12.9230769,5.72093023 C13.9384615,5.72093023 14.7692308,4.88372093 14.7692308,3.86046512 C14.7692308,2.8372093 13.9384615,2 12.9230769,2 C11.9076923,2 11.0769231,2.8372093 11.0769231,3.86046512 C11.0769231,4.88372093 11.9076923,5.72093023 12.9230769,5.72093023 Z M7.14461538,20.8930233 C7.02461538,21.4604651 7.46769231,22 8.04923077,22 L8.12307692,22 C8.55692308,22 8.92615385,21.7023256 9.02769231,21.2744186 L10.5230769,14.5581395 L12.4615385,16.4186047 L12.4615385,21.0697674 C12.4615385,21.5813953 12.8769231,22 13.3846154,22 C13.8923077,22 14.3076923,21.5813953 14.3076923,21.0697674 L14.3076923,15.8232558 C14.3076923,15.3116279 14.1046154,14.827907 13.7353846,14.4744186 L12.3692308,13.1627907 L12.9230769,10.372093 C13.2618096,10.7676861 14.4995718,11.6999758 14.7133664,11.8334696 C15.3699597,12.2434476 17.7568042,9.09675723 17.8794187,8.89390406 C18.0726322,8.57425227 18.1222968,8.27892243 17.9001194,7.9960395 C17.5369466,7.53363715 17.1465028,7.62255859 16.8461372,7.84186047 C16.5912182,8.02798095 15.9452221,8.66804222 14.9081489,9.76204427 C14.5064165,9.31557838 14.2139566,8.92978068 14.0307692,8.60465116 L13.1076923,7.11627907 C12.5907692,6.28837209 11.5569231,5.95348837 10.6615385,6.33488372 L7.12615385,7.84186047 C6.44307692,8.13953488 6.00426683,8.78139535 6.00426683,9.53488372 L6.99206731,11.8844351 C7.14461538,12.3633113 7.45567909,12.6976744 7.92307692,12.6976744 C8.39047476,12.6976744 8.88572716,12.2971755 8.75300481,11.6837209 L7.84615385,9.53488372 L9.50769231,8.88372093 L7.14461538,20.8930233 Z"
      }));
    }
  }]);
  return Interwalk;
}(_react["default"].PureComponent);

var _default = Interwalk;
exports["default"] = _default;